import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import styled from 'styled-components';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '@mui/material/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate } from 'react-router-dom';

const LoginSection = styled.section`
  max-width: 340px;
  margin: 3rem auto;
  background: #fff;
  border-radius: 1.1rem;
  box-shadow: 0 2px 14px rgba(63,81,181,0.07);
  padding: 2.2rem 2rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const Field = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
`;

const Label = styled.label`
  font-weight: 500;
  color: #3f51b5;
  min-width: 80px;
`;

const Input = styled.input`
  padding: 0.5rem 1rem;
  border: 1px solid #cfd8dc;
  border-radius: 7px;
  font-size: 1rem;
  width: 100%;
`;


const AdminLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const userCred = await login(username, password);
      const user = userCred.user || userCred;
      if (user.email === 'admin@sb.com') {
        toast.success('Login successful!');
        navigate('/admin/dashboard');
      } else {
        toast.error('Not an admin account');
      }
    } catch (err) {
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <LoginSection>
        <h2 style={{ textAlign: 'center', color: '#3f51b5', marginBottom: '1rem' }}><LoginIcon sx={{ mr: 1 }} /> Admin Login</h2>
        <form onSubmit={handleLogin}>
          <Field>
            <Label htmlFor="username">Username</Label>
            <Input id="username" value={username} onChange={e => setUsername(e.target.value)} autoFocus autoComplete="username" />
          </Field>
          <Field>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" />
          </Field>
          <Button variant="contained" color="primary" type="submit" fullWidth disabled={loading} sx={{ mt: 2 }}>
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </form>
      </LoginSection>
      <Footer />
      <ToastContainer position="bottom-center" autoClose={2000} />
    </>
  );
};

export default AdminLoginPage;
